import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'ホーム', href: '/' },
  { label: 'サービス', href: '/services' },
  { label: 'プラン', href: '/plans' },
  { label: 'お問い合わせ', href: '/contact' },
  { label: 'プライバシーポリシー', href: '/privacy' },
];

const services = [
  'コンサルティング',
  '広告・プロモーション',
  '店舗・空間デザイン',
  '人材育成',
];

export default function Footer() {
  const location = useLocation();

  const handleNavigateTop = (href: string) => {
    if (location.pathname === href) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  return (
    <footer className="bg-[#F5F0EA] pt-16 pb-6 relative overflow-hidden">
      {/* Decorative large text */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden select-none pointer-events-none">
        <p className="text-[120px] md:text-[180px] font-black text-[#EAE5DE] leading-none tracking-tighter whitespace-nowrap">
          ALA
        </p>
      </div>

      <div className="w-full px-6 md:px-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/7e733562-7236-46f6-8831-a9c8bff9fb4c.png"
              alt="株式会社ＡＬＡ ロゴ"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-xs text-[#6B6560] leading-relaxed mb-3">
              戦略で、未来を動かす。<br />
              東京発、全国へ。
            </p>
            <p className="text-xs text-[#9C9490]">
              東京都豊島区南長崎２丁目１２番１０号<br />
              レーベンシュロス２０２号
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-bold text-[#0A0E1A] tracking-widest uppercase mb-5">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    onClick={() => handleNavigateTop(link.href)}
                    className="text-sm text-[#6B6560] hover:text-[#C8501A] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold text-[#0A0E1A] tracking-widest uppercase mb-5">
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s} className="text-sm text-[#6B6560]">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold text-[#0A0E1A] tracking-widest uppercase mb-5">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href="tel:050-8896-2530"
                className="flex items-center gap-2 text-sm text-[#6B6560] hover:text-[#C8501A] transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-base" />
                </span>
                050-8896-2530
              </a>
              <a
                href="mailto:banking@ala-info.com"
                className="flex items-center gap-2 text-sm text-[#6B6560] hover:text-[#C8501A] transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-base" />
                </span>
                banking@ala-info.com
              </a>
              <div className="mt-4">
                <Link
                  to="/contact"
                  onClick={() => handleNavigateTop('/contact')}
                  className="inline-block px-5 py-2 bg-[#0A0E1A] text-white text-xs font-medium rounded-full hover:bg-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
                >
                  お問い合わせ →
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#DDD9D3] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 relative z-10">
          <p className="text-xs text-[#9C9490]">
            © 2019–2026 株式会社ＡＬＡ All Rights Reserved.
          </p>
          <Link
            to="/privacy"
            onClick={() => handleNavigateTop('/privacy')}
            className="text-xs text-[#9C9490] hover:text-[#C8501A] transition-colors cursor-pointer"
          >
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </footer>
  );
}
